import { render, staticRenderFns } from "./MeasureEditor.vue?vue&type=template&id=3bc0df73&scoped=true"
import script from "./MeasureEditor.vue?vue&type=script&lang=js"
export * from "./MeasureEditor.vue?vue&type=script&lang=js"
import style0 from "./MeasureEditor.vue?vue&type=style&index=0&id=3bc0df73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc0df73",
  null
  
)

export default component.exports